export enum EnergyMetric {
  kWh = 'energyMetricKWh',
  MWh = 'energyMetricMWh',
  GWh = 'energyMetricGWh',
  TWh = 'energyMetricTWh',
  PWh = 'energyMetricPWh',
  MMBtu = 'energyMetricMMBtu',
  billionBtu = 'energyMetricBillionBtu',
  trillionBtu = 'energyMetricTrillionBtu',
  quadrillionBtu = 'energyMetricQuadrillionBtu',
  quintillionBtu = 'energyMetricQuintillionBtu',
}
